// removed by extract-text-webpack-plugin
module.exports = {"component":"_2p6RYWmRZ8jJqr234e_ciR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Error/error.css
// module id = 963
// module chunks = 2